export default __webpack_public_path__ + "static/media/GoodHousekeeping.6058688f.svg";